/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuthorityActions } from './authorityActions';
import { CurrentAttachmentVersionDto } from './currentAttachmentVersionDto';

export interface RpaAuthorityDto {
    /**
     * The unique ID for this instance
     */
    id: number;
    /**
     * The type of this authority
     */
    authorityTypeId: number;
    /**
     * The name the user gave to the authority
     */
    name?: string;
    /**
     * When the authority starts taking effect
     */
    startDate: string;
    /**
     * When does the authority expire
     */
    expiryDate?: string;
    /**
     * The identifier, such as a serial number, that this authority has
     */
    identifier?: string;
    /**
     * The list of documents attached to this authority
     */
    attachments: Array<CurrentAttachmentVersionDto>;
    /**
     * The RPA id
     */
    rpaId: number;
    /**
     * The actions that can be performed by the current user
     */
    availableActions: AuthorityActions;
    /**
     * ${swagger.Authority.status}
     */
    status: RpaAuthorityDto.Status;
    /**
     * Has this authority been archived
     */
    archived: boolean;
    /**
     * Is the expiry of the authority coming up
     */
    expiryStatus: RpaAuthorityDto.ExpiryStatus;
    dependentOnAuthorityId?: number;
    /**
     * The timestamp when the entity was first stored
     */
    creationTime: string;
    /**
     * ${swagger.Generic.creationBy}
     */
    creationById?: number;
    /**
     * The timestamp when the entity was last stored
     */
    modificationTime?: string;
    /**
     * ${swagger.Generic.modificationBy}
     */
    modificationById?: number;
}
export namespace RpaAuthorityDto {
    export type Status = 'NEW' | 'RECORDED' | 'DELETED';
    export const Status = {
        NEW: 'NEW' as Status,
        RECORDED: 'RECORDED' as Status,
        DELETED: 'DELETED' as Status
    };
    export type ExpiryStatus = 'OK' | 'UPCOMING' | 'EXPIRED';
    export const ExpiryStatus = {
        OK: 'OK' as ExpiryStatus,
        UPCOMING: 'UPCOMING' as ExpiryStatus,
        EXPIRED: 'EXPIRED' as ExpiryStatus
    };
}
